import { console }	from "ts-base/platform";

export type Logger		= Record<Logger.Level, Logger.Action>;

export namespace Logger {
	export type Level	= typeof Level[number];
	export const Level	= [ "error", "warn", "info", "debug" ] as const;
	export const isLevel	= (it:string):it is Level	=> Level.includes(it as Level);

	//-----------------------------------------------------------------------------

	export type Action	= (...data:ReadonlyArray<unknown>) => void;

	export type Options	= {
		tag:			string,
		minimumLevel:	Level,
		withTimestamp:	boolean,
	};

	export const create	= (opts:Options):Logger => ({
		debug:	logAction(opts, stdout,	"debug"),
		info:	logAction(opts, stdout,	"info"),
		warn:	logAction(opts, stdout,	"warn"),
		error:	logAction(opts, stdout, "error"),
	});

	const logAction	= (opts:Options, target:Action, level:Level):Action =>
		(...data:ReadonlyArray<unknown>):void => {
			if (priority[level] >= priority[opts.minimumLevel]) {
				target(...prefix(level, opts), ...data);
			}
		};

	const priority:Record<Level, number>	= {
		debug:	1,
		info:	2,
		warn:	3,
		error:	4,
	};

	const prefix	= (level:string, opts:Options):ReadonlyArray<string>	=> [
		...(opts.withTimestamp ? [ new Date().toISOString() ] : []),
		`[${level.toUpperCase()}]`,
		`[${opts.tag}]`,
	];

	const stdout:Action	= (...data:ReadonlyArray<unknown>) => {
		console.log(...data);
	};

	export const ignore:Logger	= {
		debug:	() => {},
		info:	() => {},
		warn:	() => {},
		error:	() => {},
	};
}
